import { useTranslation } from "react-i18next"
import Tooltip from "../Tooltip"

interface ActionProp {
    onClick: () => void
}

export function EditAction({onClick}: ActionProp) {
    const {t} = useTranslation()
    return <Tooltip text={t("form.edit")}>
        <button className="hover:text-primary" onClick={onClick}>
            <i className="fa-sharp fa-light fa-pencil" />
        </button>
    </Tooltip>
}

export function DeleteAction({onClick}: ActionProp) {
    const {t} = useTranslation()
    return <Tooltip text={t("form.delete")}>
        <button className="hover:text-danger" onClick={onClick}>
            <i className="fa-sharp fa-light fa-trash-can" />
        </button>
    </Tooltip>
}